import type { SyncProductsQueryFromURLPayload } from '../types/ProductsQueryState';
import type { SortOption } from '../types/SortOption';

export const markActiveSortOption = (
  sortOptions: SortOption[],
  activeSort: SyncProductsQueryFromURLPayload['activeSort'],
): SortOption[] =>
  sortOptions.map((option) => ({
    ...option,
    active:
      activeSort != null &&
      option.key === activeSort.key &&
      option.descending === activeSort.descending,
  }));
